module.exports = __webpack_public_path__ + "app/heySpace/components/App/assets/newNotification.mp3";